import {
  createTableDefinition,
  type TableDefinition,
} from '@/features/shared/components/tableSystem/tableDefinition';
import { getDetailLabel } from '@/shared/copy/details';

export type CoverageRunHistorySortKey =
  | 'capturedAt'
  | 'linesPct'
  | 'functionsPct'
  | 'branchesPct'
  | 'statementsPct'
  | 'branch';

export const coverageRunHistoryTableDefinition: TableDefinition<
  CoverageRunHistorySortKey,
  'unused'
> = createTableDefinition({
  title: 'Runs',
  searchAriaLabel: 'Search coverage runs',
  columns: [
    { field: 'run', label: getDetailLabel('run'), mandatory: true, defaultVisible: true },
    { field: 'lineCoverage', label: 'Line', defaultVisible: true },
    { field: 'functionCoverage', label: 'Function', defaultVisible: true },
    { field: 'branchCoverage', label: 'Branch', defaultVisible: true },
    { field: 'statementCoverage', label: 'Statement', defaultVisible: true },
    { field: 'details', label: getDetailLabel('details'), defaultVisible: true },
    { field: 'actions', label: getDetailLabel('actions'), defaultVisible: true },
  ],
  defaultSortKey: 'capturedAt',
  defaultSortDirection: 'desc',
  sortOptions: [
    { key: 'capturedAt', label: 'Captured' },
    { key: 'linesPct', label: 'Line' },
    { key: 'functionsPct', label: 'Function' },
    { key: 'branchesPct', label: 'Branch' },
    { key: 'statementsPct', label: 'Statement' },
    { key: 'branch', label: 'Branch name' },
  ],
  sortFieldMap: {
    capturedAt: 'capturedAt',
    linesPct: 'linesPct',
    functionsPct: 'functionsPct',
    branchesPct: 'branchesPct',
    statementsPct: 'statementsPct',
    branch: 'branch',
  },
  statusOptions: [],
});
